<div class="auth-holder">
  <div>
    <!--<p *ngIf="validatedSMS == true && phoneNumber != null && validatedPassword && !smsSent && welcomeText == null" class="header_title">{{'2FA.CODE' | translate}}</p>-->
    <!--<p *ngIf="validatedSMS == true && phoneNumber != null && validatedPassword && !smsSent && welcomeText != null" class="header_title">{{welcomeText}}</p> -->

    <div *ngIf="validatedSMS == true && phoneNumber != null && !shouldChangePhone && validatedPassword && !smsSent"
      class="flex-col align-items-center text-center">
      <p class="header_title">Pour valider votre identité</p>
      <p class="dark-blue text-md bold">CLIQUEZ SUR LE BOUTON CI-DESSOUS POUR RECEVOIR PAR SMS VOTRE CODE DE SÉCURITÉ
      </p>
      <div class="flex-cent">
        <button class="action-button" (click)="sendSms()">ENVOYER LE CODE</button>
      </div>
      <p class="no-margin text-md dark-blue">Le numéro de téléphone enregistré : <br><span
          class="bold light-blue">{{phoneNumber}}</span></p>
      <p *ngIf="changeablePhone" class="light-blue text-xs pointer" (click)="shouldChangePhone = true">Changer de numéro
        de téléphone</p>
    </div>

    <!-- CHANGER LE TEXTE EN DUR -->
    <div *ngIf="validatedSMS == true && phoneNumber != null && validatedPassword && smsSent && !shouldChangePhone"
      class="flex-col align-items-center text-center w-three-quarters margin-auto">
      <p class="text-md no-margin gray-blue">Pour finaliser votre identité</p>
      <p class="text-md dark-blue bold">MERCI DE SAISIR LE CODE DE SÉCURITÉ À 6 CHIFFRES REÇU CI-DESSOUS</p>
      <form *ngIf="validatedSMS == true && phoneNumber != null && validatedPassword && smsSent && !shouldChangePhone"
        action="post" style="margin-bottom: 10px;">
        <p-inputOtp [(ngModel)]="value" name="otp" [integerOnly]="true" [length]="6" (ngModelChange)="validate()" />
      </form>
      <p class="resend-title dark-blue bold text-md no-margin mb-20">Vous n'avez pas reçu votre code ?</p>
      <p *ngIf="retries != 1 && retries >= 0 && validatedPassword && !shouldChangePhone && smsSent"
        class="resend text-sm dark-blue pointer mb-10" (click)="resendSMS()">Me renvoyer le code
        au <span class="bold light-blue">{{phoneNumber}}</span>
        ({{retries}} {{'2FA.REMAINING' | translate}}</p>
      <p *ngIf="retries == 1 && validatedPassword && !shouldChangePhone && smsSent"
        class="resend pointer text-sm dark-blue mb-10" (click)="resendSMS()">Me renvoyer le code au <span
          class="bold light-blue">{{phoneNumber}}</span>
        ({{retries}} {{'2FA.ONE-REMAINING' | translate}}</p>
    </div>

    <div
      *ngIf="validatedSMS == true && (phoneNumber == null || shouldChangePhone) && phoneChangeable  && validatedPassword">
      <p class="header_title">Saisissez votre numéro de téléphone</p>
      <div style="display: flex; width: 100%; justify-content: space-between; align-items: center; gap: 10px;">
        <input type="text" id="phone-txt" class="password-text" (keyup)="resetPhoneError()"
          placeholder="{{getPhoneNumberPlaceholder()}}">
        <button class="button-blue" style="width: 30%" (click)="sendPhoneNumber()">Envoyer</button>
      </div>
    </div>
    <div *ngIf="password != null && password.length > 3 && validatedPassword == false">
      <!--
      <p *ngIf="welcomeText == null" class="header_title">{{'2FA.CODE-PERSONAL' | translate}}</p>
      <p *ngIf="welcomeText != null" class="header_title">{{welcomeText}}</p>
      -->
      <div class="text-center">
        <p class="no-margin gray-blue">Pour commencer, veuillez confirmer votre identité</p>
        <p class="header_title dark-blue bold">{{password}}</p>
      </div>

      <div class="flex w-full margin-auto" style="max-width: 350px">
        <input type="text" id="pass-txt" class="password-text w-full" placeholder="Votre réponse"
          (keyup)="shouldCalculateError = false">
        <button class="submit-button" id="pass-butt" (click)="sendPassKey()">ok</button>

      </div>
    </div>
    <div *ngIf="(isValidationCodeError && shouldCalculateError) || noMoreSMS || isWrongPhoneError"
      class="dfa-error-message">

      <p *ngIf="isValidationCodeError && shouldCalculateError && validatedPassword"
        style="color: red; margin-bottom: 0; text-align: center; margin-top: 12px">{{'2FA.ERROR' | translate}}</p>
      <p *ngIf="isValidationCodeError && shouldCalculateError && !validatedPassword"
        style="color: red; margin-bottom: 0; text-align: center; margin-top: 12px">
        La réponse saisie est incorrecte. Veuillez réessayer.
      </p>

      <div *ngIf="isValidationCodeError && shouldCalculateError && validationErrorObj != null && validationErrorObj.code == 400 && validationErrorObj.attemptsRemaining != null"
        class="p-20 bg-pastel-yellow radius-10 flex gap-10 align-items-center margin-auto mt-20"
        style="border: solid 1px #F7D558; max-width: 450px;">
        <img src="assets/warning.svg" alt="warning" width="20px">
        <p *ngIf="validationErrorObj.attemptsRemaining == 1" class="no-margin brown">Il vous reste {{validationErrorObj.attemptsRemaining}} tentative avant un blocage temporaire.</p>
        <p *ngIf="validationErrorObj.attemptsRemaining != 1" class="no-margin brown">Il vous reste {{validationErrorObj.attemptsRemaining}} tentatives avant un blocage temporaire.</p>
      </div>

      <div *ngIf="isValidationCodeError && shouldCalculateError && validationErrorObj != null && validationErrorObj.code == 429"
        class="p-20 bg-pastel-yellow radius-10 flex gap-10 align-items-center margin-auto mt-20"
        style="border: solid 1px #F7D558; max-width: 450px;">
        <img src="assets/warning.svg" alt="warning" width="20px">
        <p class="no-margin brown">
          <span class="bold">Votre compte est temporairement bloqué.</span><br /> Suite à plusieurs tentatives
          incorrectes, l’accès est suspendu pendant
          <span class="bold">1 minute</span> afin de protéger votre compte contre toute tentative frauduleuse.
        </p>
      </div>

      <!-- <div *ngIf="isValidationCodeError && shouldCalculateError"
        class="p-20 bg-pastel-red radius-10 flex gap-10 align-items-center margin-auto mt-20"
        style="border: solid 1px #FECBCB; max-width: 450px;">
        <img src="assets/warning.svg" alt="warning" width="20px">
        <p class="no-margin strong-red">
          <span class="bold">Votre compte est temporairement bloqué.</span><br />
          Vous avez dépassé le nombre maximal de tentatives autorisées. Pour des raisons de sécurité, l’accès est
          désormais bloqué. Veuillez contacter l’organisateur du scrutin afin de rétablir votre accés.
        </p>
      </div>-->
      <p *ngIf="noMoreSMS" style="color: red;">{{'2FA.NO-MORE-SMS' | translate}}</p>
      <p *ngIf="isWrongPhoneError" style="color: red; margin-bottom: 0; text-align: center; margin-top: 12px">Numéro
        incorrect, merci de saisir un numéro existant</p>
    </div>
    <p class="resend text-center light-blue pointer"
      *ngIf="smsSent && phoneChangeable && !shouldChangePhone && validatedPassword && phoneNumber != null"
      (click)="shouldChangePhone = true">Changer ce numéro</p>

    <!-- <div *ngIf="isValidationCodeError && shouldCalculateError" class="margin-auto mt-20">
      <p class="dark-gray text-sm text-center no-margin">
        🔐 Pourquoi ces vérifications ? <br /><br />
        Pour protéger votre vote, nous limitons le nombre de tentatives d’accès. Cela
        empêche toute personne malveillante d’essayer de se connecter à votre place. <br /><br />
        En cas d’erreurs répétées, votre accès peut être temporairement bloqué. Pas d’inquiétude : il sera réactivé
        automatiquement après un court délai. <br /><br />
        Merci de votre compréhension — votre sécurité est essentielle.
      </p>
    </div> -->
  </div>
</div>
